var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingGradientBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 761,
    viewBox: "0 0 320 761",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306 2H14C7.37258 2 2 7.37258 2 14V747C2 753.627 7.37258 759 14 759H306C312.627 759 318 753.627 318 747V14C318 7.37258 312.627 2 306 2Z",
    stroke: "url(#paint0_linear_32_831)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_831",
    x1: 79.5,
    y1: -16.679,
    x2: 79.489,
    y2: 910.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB99FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#040404"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingGradientBorder);
export default __webpack_public_path__ + "static/media/pricing-gradient-border.e8bd87cdfafec54cadf1ef359a3a86fd.svg";
export { ForwardRef as ReactComponent };